const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
import floorplan1 from './img-6.jpg';
import floorplan2 from './img-21.jpg';

const floorPlanFiles = new Set(['./img-6.jpg', './img-21.jpg']);

const sorted = Object.entries(photoModules)
  .filter(([path]) => !floorPlanFiles.has(path))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const uhrineves4Images: string[] = sorted;

export const uhrineves4FloorPlans = [
  { image: floorplan1, label: "Půdorys bytu" },
  { image: floorplan2, label: "Půdorys bytu – varianta" },
];
